<form [formGroup]="requestPasswordFormGroup">
  <div class="password-request">
    <ng-container *ngIf="!isSent">
      <h2>Request New Password</h2>
      <div class="password-request__container">
        <mat-form-field class="form-field--fill">
          <mat-label>Email address used when registering</mat-label>
          <input matInput [formControl]="emailAddress" id="email" type="text" />
          <mat-error comFormMessageName="emailAddress" validation="required">Required</mat-error>
          <mat-error comFormMessageName="emailAddress" validation="pattern">The email format is incorrect</mat-error>
        </mat-form-field>
        <p class="password-request__link">
          <span (click)="home()" class="password-request__link--text">Cancel</span>
        </p>

        <div class="password-request__buttons">
          <button class="password-request__buttons--request" mat-raised-button (click)="requestNewPassword(requestPasswordFormGroup)">
            Request New Password
          </button>
        </div>
        <p *ngIf="showErrorMessage">
          <mat-error
            >There was a problem processing your request.<br />
            Please check your email address.
          </mat-error>
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="isSent">
      <h2>Request sent successfully</h2>
      <div class="password-request__container">
        <div>
          <p>
            If the details you entered match our records, an email will be sent to the address registered on the account that you requested the
            password reset for.
          </p>
          <p>This email will detail further instructions on how to complete the password reset process.</p>
        </div>
        <div class="password-request__buttons">
          <button class="password-request__buttons--request" mat-raised-button (click)="startLogin()">Return To Log In</button>
        </div>
      </div>
    </ng-container>
  </div>
</form>
